import React from "react";
import {Form} from "react-bootstrap";

export function AGCCheckBox({formik, name, toolTip, id, value, forUpdate = false, required=true}) {

    return (
        <>
            <Form.Label className={required ? 'required' : ''}>{name}</Form.Label>
            <Form.Check className="pt-3 pb-2"
                id={id}
                type="checkbox"
                label={name}
                checked={value}
                onChange={formik.handleChange}
                disabled={forUpdate}
            />
            <Form.Text className="text-muted">{toolTip}</Form.Text>

        </>
    );
}
